/**
 * CAD 命令类型枚举。
 */
export enum CadCommandType {
  /** 测试创建盒体命令。 */
  TEST_CREATE_BOX = 'test_create_box',

  /** 创建草图命令。 */
  SKETCH_CREATE = 'sketch_create',
  /** 添加直线草图实体命令。 */
  SKETCH_ADD_LINE = 'sketch_add_line',
  /** 添加圆草图实体命令。 */
  SKETCH_ADD_CIRCLE = 'sketch_add_circle',
  /** 添加矩形草图实体命令。 */
  SKETCH_ADD_RECTANGLE = 'sketch_add_rectangle',
  /** 添加圆弧草图实体命令。 */
  SKETCH_ADD_ARC = 'sketch_add_arc',

  /** 创建基础盒体命令。 */
  PRIMITIVE_BOX = 'primitive_box',
  /** 创建基础圆柱体命令。 */
  PRIMITIVE_CYLINDER = 'primitive_cylinder',
  /** 创建基础球体命令。 */
  PRIMITIVE_SPHERE = 'primitive_sphere',
  /** 创建基础圆锥体命令。 */
  PRIMITIVE_CONE = 'primitive_cone',
  /** 创建基础棱锥体命令。 */
  PRIMITIVE_PYRAMID = 'primitive_pyramid',

  /** 拉伸特征命令。 */
  EXTRUDE = 'extrude',
  /** 圆角特征命令。 */
  FILLET = 'fillet',
  /** 倒角特征命令。 */
  CHAMFER = 'chamfer',
  /** 旋转特征命令。 */
  REVOLVE = 'revolve',
  /** 抽壳特征命令。 */
  SHELL = 'shell',
  /** 筋特征命令。 */
  RIB = 'rib',
  /** 孔特征命令。 */
  HOLE = 'hole',

  /** 删除命令。 */
  DELETE = 'delete',
  /** 移动命令。 */
  MOVE = 'move',
  /** 复制命令。 */
  COPY = 'copy',
  /** 镜向命令。 */
  MIRROR = 'mirror',
  /** 编辑端点命令。 */
  EDIT_ENDPOINT = 'edit_endpoint',
}
